import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useLogout from "../../hooks/useLogout";
import { categoryDDAPI, doctorDDAPI, productDDAPI } from "../../api/dropdown";
import { toast } from "react-toastify";
import { addBlogAPI, listBlogAPI, updateBlogAPI } from "../../api/blog";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { Form } from "reactstrap";
import MyInput from "../../MyComp/UI/form/MyInput";
import MySelect from "../../MyComp/UI/form/MySelect";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import CKEditor from "../../MyComp/UI/CK Editor/index";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyCheck from "../../MyComp/UI/form/MyCheck";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import { BASE_URL_IMG } from "../../assets/constants";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import { UserAvatarCell } from "../../MyComp/ImagePre/UserAvatarCell";

const Blog = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      loading: false,
      data: [],
      doctorList: [],
      categoryDD: [],
      blog_image: null,
      blog_img: null,
      publish: false,
    },
  });
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const loading = watch("loading");
  const data = watch("data");
  const [column, setColumn] = useState([
    {
      name: "Published By",
      selector: (row) => row?.row?.doctor?.label,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "6px 0",
          }}
        >
          {/* <img
            onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.doctor?.dr_image)}
            src={row?.doctor?.dr_image ? `${BASE_URL_IMG}${row.doctor?.dr_image}` : "/default-avatar.png"}
            alt={row?.doctor?.label || "doctor"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          /> */}
          <UserAvatarCell
            row={row}
            image={row?.doctor?.dr_image ? `${BASE_URL_IMG}${row.doctor?.dr_image}` : "/default-avatar.png"}
            name={row?.doctor?.label}
            handleImageOpenPreview={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.doctor?.dr_image)}
          />

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontWeight: 600,
                fontSize: "15px",
                color: "#111827",
                lineHeight: "1.2",
              }}
            >
              {row?.doctor?.label || "N/A"}
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {row?.doctor?.qualification || ""}
            </span>
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Blog",
      selector: (row) => row?.blog_title,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "6px 0",
          }}
        >
          {/* <img
            onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.blog_img)}
            src={row?.blog_img ? `${BASE_URL_IMG}${row.blog_img}` : "/default-avatar.png"}
            alt={row?.blog_title || "blog"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          /> */}
           <UserAvatarCell
            row={row}
            image={row?.doctor?.blog_image ? `${BASE_URL_IMG}${row.doctor?.blog_image}` : "/default-avatar.png"}
            name={row?.blog_title}
            handleImageOpenPreview={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.doctor?.blog_image)}
          />

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontWeight: 600,
                fontSize: "15px",
                color: "#111827",
                lineHeight: "1.2",
              }}
            >
              {row?.blog_title || "N/A"}
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {/* {row?.mobile || row?.contact_number} */}
            </span>
          </div>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Category",
      selector: (row) => row?.category?.label,
      sortable: true,
    },

    {
      name: "Action",
      wrap: true,
      width: "150px",
      cell: (row) => (
        <div>
          <Button
            outline
            color={row?.publish ? `warning` : `success`}
            size={`xs`}
            className={`mx-1`}
            onClick={() => handleTogglePublish(row)}
            data-bs-toggle="tooltip"
            title={row?.publish ? "Achieve Product" : "Publish Product"}
          >
            <Icon name={row?.publish ? "inbox-in" : "inbox-out"}></Icon>
          </Button>{" "}
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            {" "}
            <Icon name="edit" />
          </Button>
        </div>
      ),
    },
  ]);
  useEffect(() => {
    getDoctorList();
    getBlogList();
    getCategory();
  }, []);
  const getDoctorList = () => {
    doctorDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("doctorList", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("doctorList", []);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getBlogList = () => {
    setValue("loading", true);
    listBlogAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("data", res.data.data);
          setValue("loading", false);
        } else if (res.data.status === false) {
          setValue("loading", false);
          setValue("data", []);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("loading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const getCategory = () => {
    categoryDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const handleImageOpenPreview = (row, name) => {
    // setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const resetForm = () => {
    setValue("blog_title", "");
    setValue("category", "");
    setValue("doctor", "");
    setValue("blog_img", null);
    setValue("blog_image", null);
    setValue("publish", false);
    setMode("Add");
  };
  const onFormSubmit = (data) => {
    const formData = new FormData();
    const extra_product_description = window?.CKEDITOR?.instances.extra_blog_details?.getData();
    const cleanedContent = extra_product_description.replace(/&nbsp;/g, " ");
    formData.append("blog_title", watch("blog_title"));
    formData.append("category", watch("category")?.value);
    formData.append("doctor", watch("doctor")?.value);
    formData.append("extra_blog_details", cleanedContent);
    formData.append("publish", watch("publish"));
    const blogImg = watch("blog_img");
    if (blogImg instanceof File) {
      formData.append("blog_img", blogImg);
    } else if (typeof blogImg === "string") {
      formData.append("blog_img", blogImg);
    }
    if (mode == "Edit") {
      formData.append("id", watch("selectedRow")?.id);
    }
    if (mode == "Add") {
      addBlogAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            setIsOpen(false);
            getBlogList();
            setValue("isLoading", false);
            resetForm();
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
    if (mode == "Edit") {
      updateBlogAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            setIsOpen(false);
            getBlogList();
            setValue("isLoading", false);
            resetForm();
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
  };
  const handleTogglePublish = (row) => {
    setValue("isPub", true);
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const confirmStatusChange = (data) => {
    const formData = new FormData();
    const updatedPub = watch("selectedRow").publish === true ? false : true;
    if (watch("isPub")) {
      formData.append("publish", updatedPub);
    }
    formData.append("id", watch("selectedRow")?.id);
    setValue("isLoading", true);
    updateBlogAPI(formData)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getBlogList();
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
          resetForm();
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("blog_title", row?.blog_title);
    setValue("category", row?.category);
    setValue("doctor", row?.doctor);
    setValue("blog_img", BASE_URL_IMG + row?.blog_img);
    setValue("blog_image", BASE_URL_IMG + row?.blog_img);
    setValue("publish", row?.publish);
    setTimeout(() => {
      if (window?.CKEDITOR?.instances?.extra_blog_details) {
        window.CKEDITOR.instances.extra_blog_details.setData(row?.extra_blog_details || ""); // Set existing content
      }
    }, 500);
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  return (
    <>
      <Head title={"Blogs"} />
      <Content>
        <BlockHead>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Blogs"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetForm();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="4" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Blog Title"}
                      name={"blog_title"}
                      placeholder={"Enter blog title"}
                      required
                      min={2}
                      max={50}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Category"}
                      name={"category"}
                      placeholder={"Select category"}
                      required
                      options={watch("categoryDD")}
                    />
                  </Col>
                  <Col md="2" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Published by"}
                      name={"doctor"}
                      placeholder={"Select doctor name"}
                      options={watch("doctorList")}
                      required
                    />
                  </Col>
                  <Col md="2">
                    <ImageUpload
                      id="blog_image"
                      watch={watch}
                      trigger={trigger}
                      setError={setError}
                      clearErrors={clearErrors}
                      label={"Blog Image"}
                      errors={errors}
                      register={register}
                      image={"blog_img"}
                      image_url={"blog_image"}
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      getValues={getValues}
                    />
                  </Col>
                  <Col md={2}>
                    <MyCheck
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Publish"}
                      name={"publish"}
                      placeholder={"Is Blog Ready to go live"}
                    />
                  </Col>
                  <Col md={12}>
                    <CKEditor title={"Extra Blog Details"} id="extra_blog_details" />
                  </Col>
                </Row>
                <Col md="2" className={``}>
                  <div className="form-group" style={{ marginTop: "31px" }}>
                    <MyButton isLoading={isLoading} mode={mode} />
                  </div>
                </Col>
              </Form>
            </PreviewAltCard>
          )}
          <MyDataTable data={data || []} columns={column} title={"Blog List"} isLoading={loading} />
        </Block>
      </Content>
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />

      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default Blog;
